<template>
  <div class="evaluation-view-container">
    <evaluation-base
      :assignment="assignment"
      :layout="layout"
      :evaluation="evaluation"
      :branch="branch"
    />
  </div>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'
import EvaluationGuards from '@/guards/evaluation.guards'
import EvaluationBase from '@/modules/evaluation/evaluation-base'

export default {
  name: 'EvaluationView',
  components: {
    EvaluationBase
  },
  data () {
    return {
      processedEvaluation: {}
    }
  },
  computed: {
    ...mapGetters('assignments', {
      assignment: 'item'
    }),
    ...mapGetters('layouts', {
      layout: 'item'
    }),
    ...mapGetters('evaluations', {
      evaluation: 'item'
    }),
    ...mapGetters('branchTypes', {
      branchTypes: 'items'
    }),
    ...mapGetters('branches', {
      branch: 'item'
    }),
    title: function () {
      return this.layout.name
    }
  },
  mounted () {
    this.processedEvaluation = this.evaluation
  },
  beforeRouteEnter: EvaluationGuards.onQueryEvaluate,
  beforeRouteUpdate: EvaluationGuards.onQueryEvaluate
}
</script>

////////////////////////////////////////////
//                                    STYLE
////////////////////////////////////////////

<style
  lang="scss"
  scoped
>
.evaluation-view-container {
  background-color: #f3f3f3;
  height: 100vh;
  width: 100vw;
  margin-bottom: -8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .left-layout {
    height: 100%;
    background-color: white;
    border-right: 1px solid $color-font-disabled;
  }
  .main-view-layout {
    background-color: white;
    height: 100%;
    width: 75%;
    position: relative;
    .main-container {
      height: calc(100% - 50px);
      position: absolute;
      bottom: 0;
      width: 100%;
      border-right: 1px solid $color-font-disabled;
      .comment-modal {
        height: 0;
        transition: all 0.3s ease-in-out;
        display: none;
      }
      .modalShow {
        height: 300px;
        transition: all 0.3s ease-in-out;
      }
    }
  }
  .right-view-container {
    height: 100%;
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/evaluation/evaluation-view.vue